import React, { useState, Dispatch, SetStateAction } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import { apiCheckoutConsultant } from 'src/environments/CheckoutConsultantAPP/api';
import { IConsultantData } from 'src/environments/CheckoutConsultantAPP/interfaces';
import { IPlanData } from 'src/environments/Checkout/interfaces';

import CreditCardForm from './components/CreditCardForm';

import loadingGIF from '../../../../../../assets/gifs/loading.png';
import ConcludePurchase from './components/ConcludePurchase';

type Props = {
  consultantData: IConsultantData;
  planData: IPlanData;
  setComponent: Dispatch<SetStateAction<number>>;
  platform: string;
};

export default function PurchasePayment({
  consultantData,
  planData,
  setComponent,
  platform,
}: Props): JSX.Element {
  const [showCardForm, setShowCardForm] = useState(false);

  const { token } = useParams();

  const {
    isLoading: loadingCardsIds,
    isError,
    data: cardsIds,
  } = useQuery(
    ['getConsultantCardsIds', token],
    async () => apiCheckoutConsultant.getConsultantCardsIds(token),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: () => {},
      refetchOnWindowFocus: false,
    }
  );

  if (loadingCardsIds || isError) {
    return <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />;
  }

  return (
    <>
      {showCardForm || cardsIds.length === 0 ? (
        <CreditCardForm
          consultantData={consultantData}
          setShowCardForm={setShowCardForm}
          hasCards={cardsIds.length > 0}
        />
      ) : (
        <ConcludePurchase
          consultantData={consultantData}
          setShowCardForm={setShowCardForm}
          cardsIds={cardsIds}
          planData={planData}
          setComponent={setComponent}
          platform={platform}
        />
      )}
    </>
  );
}
